// extracted by mini-css-extract-plugin
export var center = "layout-module--center--1GXGU";
export var body = "layout-module--body--yvYHu";